import { ErrorEvent } from './events';

/**
 * Report a non-fatal error from the client script. This dispatches the
 * `800dni.error` event, which the event tracker batches and POSTs to
 * `/dniEvents` (kind `error`); the backend persists it and surfaces it to our
 * error tracker. Use this for conditions we want visibility on but that should
 * not interrupt the page — e.g. a GA cookie in a format we cannot parse.
 */
export const reportError = (message: string, context?: Record<string, unknown>): void => {
    window.dispatchEvent(new CustomEvent<ErrorEvent>('800dni.error', {
        detail: { message, context },
    }));
};
